import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import PasswordInfo from "../../Components/PasswordInfo";
import "./index.scss";

const icons = {
  email: "/assets/icons/email-icon.svg",
  password: {
    vision: "/assets/icons/eye-vision-icon.svg",
    noVision: "/assets/icons/eye-icon.svg",
  },
};

export default function Input({
  id,
  name,
  value,
  placeholder = "Placeholder",
  handleChange,
  type = "text",
  label = "Label",
  icon,
  toggleType,
  disabled,
  change = false,
  changeInfo,
  maxLength = 999,
  autoComplete = "",
  readOnly=false
}) {
  let inputIcon = null;
  let passwordIcon = null;
  const location = useLocation();
  const [imagePath, setImagePath] = useState("./");
  const [currentValue, setCurrentValue] = useState("");
  const [showHelper, setShowHelper] = useState(false);

  useEffect(() => {
    if (
      location.pathname === "/settings/personal-info" ||
      location.pathname === "/settings/security" ||
      location.pathname === "/settings/providers" ||
      location.pathname === "/settings/locations" ||
      location.pathname === "/settings/payment-method" ||
      location.pathname === "/settings/faq"
    ) {
      setImagePath("../.");
    } else {
      setImagePath("");
    }
  }, [location]);

  if (
    (id === "password" || id === "password_confirm" || id === "password_old") && toggleType
  ) {
    passwordIcon = icon ? icons.password.noVision : icons.password.vision;
  } else {
    inputIcon = icons[type];
  }

  const showPasswordInfo = showHelper && (id === 'password' || id === 'password_confirm' || id === 'password_old');

  return (
    <div className="input__group">
      <div className="input__inner">
        <label htmlFor={id}>{label}</label>
        {change && (
          <div onClick={changeInfo} className="input__upperBtn">
            Change
          </div>
        )}
      </div>
      <div className="input__fill">
        <input
          autoComplete={autoComplete}
          className="input__fill-input"
          id={id}
          name={name}
          type={type}
          value={value ?? ""}
          placeholder={placeholder}
          maxLength={maxLength}
          onChange={(event) => {
            if (handleChange) {
              handleChange(event);
            }
            setCurrentValue(event.target.value);
          }}
          onFocus={() => {setShowHelper(true)}}
          onBlur={() => {setShowHelper(false)}}
          disabled={disabled}
          readOnly={readOnly}
        />
        {inputIcon && (
          <img
            className="input__fill-img"
            src={imagePath + inputIcon}
            alt="icon"
          />
        )}
        {passwordIcon && (
          <img
            className="input__fill-img"
            src={imagePath + passwordIcon}
            alt="icon"
            onClick={toggleType}
          />
        )}
        {showPasswordInfo && <PasswordInfo value={currentValue} />}
      </div>
    </div>
  );
}
